import * as React from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0TagStatus, StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

/* TO DO: return OfferLetterStatusesEnum as the status
 * in the Entity to get the type from GraphQl
 * Then use it as the status type and algo also in the Record
 * from statusLabel, statusColor and tooltipDescription.
 * Remove the if from line 23
 */
const STATUSES = ['created', 'pending_signature', 'accepted', 'canceled', 'declined']

interface Props {
  status: string
}
export const OfferLetterStatusTag = ({ status }: Props) => {
  const [openTooltip, toggleTooltip] = useToggle()

  if (!STATUSES.includes(status)) {
    return null
  }

  const statusLabel: Record<string, string> = {
    created: i18n.t('ats.offer_letter.status.created'),
    pending_signature: i18n.t('ats.offer_letter.status.pending'),
    accepted: i18n.t('ats.offer_letter.status.signed'),
    canceled: i18n.t('ats.offer_letter.status.canceled'),
    declined: i18n.t('ats.offer_letter.status.declined'),
  }

  const satusColor: Record<string, StatusVariant> = {
    created: 'info',
    pending_signature: 'info',
    canceled: 'critical',
    declined: 'critical',
    accepted: 'warning',
  }

  const tooltipDescription: Record<string, string> = {
    created: i18n.t('ats.offer_letter.tooltip.created'),
    pending_signature: i18n.t('ats.offer_letter.tooltip.pending'),
    accepted: i18n.t('ats.offer_letter.tooltip.signed'),
    canceled: i18n.t('ats.offer_letter.tooltip.canceled'),
    declined: i18n.t('ats.offer_letter.tooltip.declined'),
  }

  return (
    <Tooltip.Alt
      attachment="top center"
      open={openTooltip}
      toggle={toggleTooltip}
      label={tooltipDescription[status]}
    >
      <F0TagStatus text={statusLabel[status] ?? ''} variant={satusColor[status] ?? 'info'} />
    </Tooltip.Alt>
  )
}
